import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from './alertMessageSlice';

import BlogService from '../services/blog.service';

export const getAllBlog = createAsyncThunk('blog/list', async (thunkAPI) => {
  try {
    const data = await BlogService.getAllBlogs();
    return { data };
  } catch (error) {
    return thunkAPI.rejectWithValue();
  }
});

export const getBlogContentById = createAsyncThunk(
  'blog',
  async ({ id, thunkAPI }) => {
    try {
      const data = await BlogService.getBlogContent({ id: id });
      return { data };
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);
